import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { CreateUserRatingsRequestDto } from "../generated/generatedTypes";

const createUserRatings = async (payload: CreateUserRatingsRequestDto): Promise<void> => {
  const response = await apiFetch("api/user-rating/bulk", {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    let errorMessage = "평가를 제출하지 못했습니다. 잠시 후 다시 시도해주세요.";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (e) {
      // Ignore if error response is not JSON or empty
    }
    throw new Error(errorMessage);
  }
};

export function useCreateUserRatings(): UseMutationResult<
  void,
  Error,
  CreateUserRatingsRequestDto
> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, CreateUserRatingsRequestDto>({
    mutationFn: createUserRatings,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["rateableParticipants", variables.eventId],
      });
    },
  });
}
